import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { CorrespondenceIssuedCategoryDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-issued-category-view',
  templateUrl: './issued-category-view.component.html',
  styleUrls: ['./issued-category-view.component.css'],
})
export class IssuedCategoryViewComponent implements OnInit {
  @Input() issuedCategories: CorrespondenceIssuedCategoryDto[];
  issuedCategoryForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<CorrespondenceIssuedCategoryDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  loading = true;
  status: boolean;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.issuedCategoryForm = this.fb.group({
      IssuedCategories: this.fb.array([]),
    });
    this.setIssuedCategory();
  }

  // method to display countries
  setIssuedCategory() {
    const control = this.issuedCategoryForm.controls
      .IssuedCategories as FormArray;
    this.issuedCategories.forEach((e) => {
      control.push(
        this.fb.group({
          IssuedCategoryName: e.IssuedCategoryName,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.issuedCategoryForm.controls
      .IssuedCategories as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to add Country
  addIssuedCategory() {
    const control = this.issuedCategoryForm.controls
      .IssuedCategories as FormArray;
    control.insert(
      0,
      this.fb.group({
        IssuedCategoryName: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteTeam(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.issuedCategoryForm.controls
          .IssuedCategories as FormArray;
        control.removeAt(index);

        if (value.id != null && value.id !== '') {
          this.filteredDelete.push(value.id);
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'issuedCategory';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('issuedCategory');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
